import React, { useEffect, useState } from "react";
import { ShieldCheck, CheckCircle2, XCircle } from "lucide-react";
import api from "../../lib/api";
import { useAuth } from "../../context/AuthContext";

export default function MyAccess() {
  const { user, permissions, isSuperAdmin } = useAuth();
  const [perms, setPerms] = useState([]);

  useEffect(() => {
    api.get("/permissions").then((r) => setPerms(r.data.permissions)).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-my-access">
      <div className="overline text-zinc-500">My profile</div>
      <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight mb-2">My access</h1>
      <p className="text-sm text-zinc-500 mb-6">
        This is the full list of backend sections. The Super Admin decides which ones you can see and edit.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4 mb-8">
        <InfoCard label="Name" value={user?.name} />
        <InfoCard label="Email" value={user?.email} />
        <InfoCard label="Role" value={roleLabel(user?.role)} accent={user?.role === "super_admin" ? "#F74B64" : undefined} icon={isSuperAdmin ? <ShieldCheck size={14} /> : null} />
      </div>

      <div className="rounded-xl border border-zinc-200 bg-white p-5 sm:p-6">
        <div className="font-display font-bold mb-4">Backend access checklist</div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {perms.map((p) => {
            const granted = isSuperAdmin || permissions.includes(p.key);
            return (
              <div key={p.key}
                   className={`flex items-start gap-3 p-3 sm:p-4 rounded-lg border ${granted ? "border-[#F74B64] bg-[#FFF5F6]" : "border-zinc-200 bg-zinc-50"}`}
                   data-testid={`my-access-${p.key}`}>
                {granted
                  ? <CheckCircle2 size={18} style={{ color: "#F74B64" }} className="mt-0.5 flex-shrink-0" />
                  : <XCircle size={18} className="text-zinc-300 mt-0.5 flex-shrink-0" />}
                <div className="min-w-0">
                  <div className={`font-semibold text-sm ${granted ? "" : "text-zinc-500"}`}>{p.label}</div>
                  <div className="text-[10px] text-zinc-400 font-mono break-all">{p.key}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

function InfoCard({ label, value, accent, icon }) {
  return (
    <div className="rounded-xl border border-zinc-200 bg-white p-5">
      <div className="overline text-zinc-500">{label}</div>
      <div className="font-display font-bold text-lg flex items-center gap-2 mt-1" style={accent ? { color: accent } : {}}>
        {icon} {value || "—"}
      </div>
    </div>
  );
}
function roleLabel(r) {
  return { super_admin: "Super Admin", admin: "Admin", staff: "Staff", customer: "Customer" }[r] || r;
}
